import { render, staticRenderFns } from "./ClaimExcessPaymentsList.vue?vue&type=template&id=16b8b2d5&"
import script from "./ClaimExcessPaymentsList.vue?vue&type=script&lang=js&"
export * from "./ClaimExcessPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports